module.exports = __webpack_public_path__ + "media/images/front/dplus_banner_movie_241009-c3e37ebd5b85ad2a3f9206de5933b616.jpg";